module.exports = __webpack_public_path__ + "static/media/error_icon.a7e6df90.svg";